import { useTranslation } from "react-i18next";
import { useEditQuestionForm } from "../hooks";
import { Active, Inactive } from "@pulse/features/Sections";
import { ActiveQuestionLayout, InactiveQuestionLayout } from "../QuestionLayouts";
import { PULSE_FIELD_LIMITS } from "@pulse/features/pulseFieldLimits";
import { Input } from "frontend-components";

function TextInputQuestionEdit() {
    const form = useEditQuestionForm();
    const { t } = useTranslation();
    return (
        <>
            <form.AppField name="questionText">
                {(field) => (
                    <field.TextArea autoFocus maxCharacters={PULSE_FIELD_LIMITS.question.text} />
                )}
            </form.AppField>
            <Input placeholder={t("question.text.placeholder")} disabled />
        </>
    );
}

function TextInputQuestionDisplay() {
    const { t } = useTranslation();
    return (
        <>
            <Input placeholder={t("question.text.placeholder")} disabled />
        </>
    );
}

export default function TextInputQuestion() {
    return (
        <>
            <Active>
                <ActiveQuestionLayout>
                    <TextInputQuestionEdit />
                </ActiveQuestionLayout>
            </Active>
            <Inactive>
                <InactiveQuestionLayout>
                    <TextInputQuestionDisplay />
                </InactiveQuestionLayout>
            </Inactive>
        </>
    );
}
